<template>
	<main class="icon_page">
		<article class="iconInfo">
			<section class="icon_form">
				<div class="icon_wrapper">
					<img src="@/assets/img/common/congrats.png" alt="축하 아이콘" loading="lazy" />
					<div class="icon_title">
						<p>{{ REGISTRATION_SUCCESS }}</p>
						<p>{{ REGISTRATION_CONGRATULATIONS }}</p>
					</div>
				</div>
				<div class="c_fieldArea">
					<button class="c_button radius-x-small primary-fill save" @click="onClickLogin">
						{{ CONFIRM_LOGIN }}
					</button>
				</div>
			</section>
		</article>
	</main>
</template>

<script setup lang="ts">
// core
import { onMounted, onUnmounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { CONFIRM_LOGIN, REGISTRATION_CONGRATULATIONS, REGISTRATION_SUCCESS } from '@/constants/title';

const isDesktop = ref(window.innerWidth > 1280);
const route = useRoute();
const router = useRouter();

const resizeHandler = () => {
	isDesktop.value = window.innerWidth > 1280; // 데스크탑 여부
};

const onClickLogin = () => {
	router.replace({
		name: 'auth/login',
		query: typeof route.query.redirect === 'string' ? { redirect: route.query.redirect } : {},
	});
};

onMounted(() => {
	window.addEventListener('resize', resizeHandler);
	const joinPath = window.localStorage.getItem('joinPath');
	if (joinPath) {
		window.localStorage.removeItem('joinPath');
	}
});
onUnmounted(() => {
	window.removeEventListener('resize', resizeHandler);
});
</script>

<style lang="scss" scoped>
.icon_page {
	max-width: 40rem;
	width: 100%;
	margin: 0 auto;
	display: flex;
	justify-content: center;
	align-items: center;
	@media screen and (max-width: 1280px) {
		padding-left: 2rem;
		padding-right: 2rem;
	}
}
.save {
	font-weight: var(--font-w-medium);
	font-size: var(--font-s-regular);
	line-height: 2.1rem;
}
</style>
